import { getSidebarStatus, getSize, setSidebarStatus, setLanguage, setSize } from '@/utils/cookies';
// import { getLocale } from '@/lang'
import { schemes, getSchemeId, switchColorScheme } from '@/colorScheme';
export var DeviceType;
(function (DeviceType) {
  DeviceType[DeviceType["Mobile"] = 0] = "Mobile";
  DeviceType[DeviceType["Desktop"] = 1] = "Desktop";
})(DeviceType || (DeviceType = {}));
export default {
  namespaced: true,
  state: () => ({
    sidebar: {
      opened: getSidebarStatus() !== 'closed',
      withoutAnimation: false
    },
    device: DeviceType.Desktop,
    // language: getLocale(),
    size: getSize() || 'mini',
    colorScheme: schemes,
    currentScheme: getSchemeId(),
    pageKey: Date.now() // 页面key值
  }),
  mutations: {
    TOGGLE_SIDEBAR(state, withoutAnimation) {
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = withoutAnimation;
      if (state.sidebar.opened) {
        setSidebarStatus('opened');
      } else {
        setSidebarStatus('closed');
      }
    },
    CLOSE_SIDEBAR(state, withoutAnimation) {
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
      setSidebarStatus('closed');
    },
    TOGGLE_DEVICE(state, device) {
      state.device = device;
    },
    SET_LANGUAGE(state, language) {
      state.language = language;
      setLanguage(state.language);
    },
    SET_SIZE(state, size) {
      state.size = size;
      setSize(state.size);
    },
    SWITCH_COLOR_SCHEME(state, id) {
      switchColorScheme(id);
      state.currentScheme = id;
    },
    SET_PAGE_KEY(state, val) {
      state.pageKey = val;
    }
  },
  actions: {
    ToggleSideBar({
      commit
    }, withoutAnimation = false) {
      commit('TOGGLE_SIDEBAR', withoutAnimation);
    },
    CloseSideBar({
      commit
    }, withoutAnimation) {
      commit('CLOSE_SIDEBAR', withoutAnimation);
    },
    ToggleDevice({
      commit
    }, device) {
      commit('TOGGLE_DEVICE', device);
    },
    SetLanguage({
      commit
    }, language) {
      commit('SET_LANGUAGE', language);
    },
    SetSize({
      commit
    }, size) {
      commit('SET_SIZE', size);
    },
    SwitchColorScheme({
      commit
    }, id) {
      commit('SWITCH_COLOR_SCHEME', id);
    }
  }
};